import { render, staticRenderFns } from "./move-portfolio-modal.vue?vue&type=template&id=4f36ee0f&scoped=true&"
import script from "./move-portfolio-modal.vue?vue&type=script&lang=js&"
export * from "./move-portfolio-modal.vue?vue&type=script&lang=js&"
import style0 from "./move-portfolio-modal.vue?vue&type=style&index=0&id=4f36ee0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f36ee0f",
  null
  
)

export default component.exports